import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ClockLoader } from "react-spinners";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./components/Login";
import Layout from "./components/Layout";
import Reservation from './reservations/Reservation';
import Card from "./components/Bullshit/Card";
import NewCat from "./Cat/NewCat";
import Success from "./Success/Success";
import Cancel from "./Success/Cancel";
import ContactUs from "./components/ContactUs";
import OwnersPage from "./components/OwnersPage";
import InformationPage from "./components/InformationPage";
import LawsPage from "./components/LawsPage";
import ConditionsPage from "./components/ConditionsPage";
import ScrollToTop from "./components/ScrollToTop";

// مكون Loading مع أنماط مدمجة
const Loading = () => {
  useEffect(() => {
    // إلغاء التمرير عند التحميل
    document.body.style.overflow = 'hidden';
    
    return () => {
      // إعادة التمرير عند الإخفاء
      document.body.style.overflow = 'visible';
    };
  }, []);
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(255, 255, 255, 0.98)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999,
      animation: 'fadeOut 0.5s ease-out 5s forwards'
    }}>
      <style>
        {`
          @keyframes fadeOut {
            0% { opacity: 1; }
            100% { opacity: 0; visibility: hidden; }
          }
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.1); }
            100% { transform: scale(1); }
          }
        `}
      </style>
      
      <div style={{
        textAlign: 'center',
        transform: 'translateY(-20%)'
      }}>
        <ClockLoader
          size={120}
          color="#C49E41"
          speedMultiplier={0.8}
          cssOverride={{
            borderWidth: '4px'
          }}
        />
     
      </div>
    </div>
  );
};

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2500); // 5 ثواني للعرض + 0.5 ثانية للتدرج

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      {isLoading && <Loading />}
      
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Reservation />} />
          <Route path="/card" element={<ProtectedRoute><Card /></ProtectedRoute>} />
          <Route path="/login" element={<Reservation />} />
          <Route path="/Cat" element={<NewCat />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/owners" element={<OwnersPage />} />
          <Route path="/information" element={<InformationPage />} />
          <Route path="/laws" element={<LawsPage />} />
          <Route path="/condition" element={<ConditionsPage />} />
          <Route path="/success" element={<Success />} />
          <Route path="/cancel " element={<Cancel />} />


        </Route>
        <Route path="/login" element={<Reservation />} />
      </Routes>
    </Router>
  );
}

export default App;